// Theme configuration for the AI Dojo Results page
// Gaming/esports aesthetic with bold colors and futuristic feel

const theme = {
  colors: {
    // Primary colors
    primary: '#00D4FF', // Electric Blue
    secondary: '#8B5CF6', // Neon Purple
    
    // Rank colors
    gold: '#FFD700', // 1st place
    silver: '#C0C0C0', // 2nd place
    bronze: '#CD7F32', // 3rd place
    fourth: '#555555', // 4th place
    
    // Background colors
    bgDark: '#0A0A0A',
    bgDarkGradient: 'linear-gradient(135deg, #0A0A0A 0%, #1A1A2E 100%)',
    bgLight: '#1A1A2E',
    bgLightGradient: 'linear-gradient(135deg, #1A1A2E 0%, #2A2A4E 100%)',
    
    // Text colors
    textPrimary: '#FFFFFF',
    textSecondary: '#E5E5E5',
    textMuted: '#AAAAAA',
    
    // Accent colors
    accent1: '#FF3864', // Neon Pink
    accent2: '#39FF14', // Neon Green
    accent3: '#FF9E00', // Neon Orange
    
    // Utility colors
    border: 'rgba(255, 255, 255, 0.1)',
    shadow: 'rgba(0, 0, 0, 0.5)',
    overlay: 'rgba(10, 10, 10, 0.8)',
    highlight: 'rgba(0, 212, 255, 0.2)'
  },
  
  fonts: {
    heading: "'Orbitron', sans-serif",
    body: "'Inter', sans-serif",
    mono: "'Roboto Mono', monospace"
  },
  
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.25rem',
    xl: '1.5rem',
    '2xl': '2rem',
    '3xl': '2.5rem',
    '4xl': '3rem',
    '5xl': '4rem'
  },
  
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  
  space: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem'
  },
  
  radii: {
    none: '0',
    sm: '0.25rem',
    md: '0.5rem',
    lg: '1rem',
    xl: '2rem',
    full: '9999px'
  },
  
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    md: '0 4px 6px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.24)',
    lg: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
    xl: '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)',
    glow: '0 0 15px rgba(0, 212, 255, 0.7)',
    goldGlow: '0 0 20px rgba(255, 215, 0, 0.7)',
    silverGlow: '0 0 15px rgba(192, 192, 192, 0.7)',
    bronzeGlow: '0 0 15px rgba(205, 127, 50, 0.7)'
  },
  
  transitions: {
    fast: 'all 0.2s ease',
    normal: 'all 0.3s ease',
    slow: 'all 0.5s ease',
    bounce: 'all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55)'
  },
  
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    '2xl': '1400px'
  },
  
  zIndices: {
    base: 0,
    overlay: 10,
    modal: 20,
    toast: 30
  }
};

export default theme;